import { initials, root } from './ProductCoverPlaceholder.css'

export type ProductCoverPlaceholderProps = {
  name: string
}

function initialsFromName(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean).slice(0, 2)

  const text = words.map((word) => word[0]?.toUpperCase() ?? '').join('')
  return text || 'VP'
}

export function ProductCoverPlaceholder({ name }: ProductCoverPlaceholderProps) {
  return (
    <div className={root} aria-hidden="true">
      <span className={initials}>{initialsFromName(name)}</span>
    </div>
  )
}
